import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {clientsUnitsStore} from '@store/clients/units/clients-units.store';
import {
  getClientsUnitsDataSource,
  putClientUnitFacturationModeDataSource
} from '@store/clients/units/clients-units.requests';

export class ClientsUnitsQuery {
  store = clientsUnitsStore;

  status$ = this.store.pipe(select((state) => state.status));
  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  clientsUnits$ = getClientsUnitsDataSource.data$();
  selectedClientsUnits$ = this.store.pipe(
    selectManyByPredicate((clientsUnitUI) => clientsUnitUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  putClientUnitFacturationMode$ = putClientUnitFacturationModeDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const clientsUnitsQuery = new ClientsUnitsQuery();
